var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css } from 'lit';
import { property } from 'lit/decorators.js';
import { customElement, PICAction, PIC, PICBase, fetchApiData, stringDecoder, exportFetchURL, exportFetchHeaders, booleanDecoder, numberDecoder, } from '../Internals';
let PICAPIDocs = class PICAPIDocs extends PICBase {
    static get styles() {
        const defaultStyle = css `
      .pic-container {
        display: flex;
        flex-direction: column;
        margin: 12px 12px 12px 0px;
        border-top: 1px solid black;
      }

      .pic-containerheader {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
      }

      .pic-containerheadercollapsable {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        position: relative;
      }

      .pic-containerheadercollapsable:hover {
        cursor: pointer;
      }

      .pointerContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        cursor: pointer;
        background-color: transparent;
      }

      .pic-containerheaderLeft {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #000000;
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
      }

      .pic-containerheaderRight,
      .pic-containeHeaderRightLabel {
        font-size: 20px;
        line-height: 20px;
        color: var(--pic-onSurfaceHighColor);
      }

      .pic-containeHeaderRightLabel {
        font-family: 'Material Design Icons';
      }

      .pic-containeHeaderRightLabel.mdi-chevron-up::before {
        font-family: 'Material Design Icons';
        content: '\u{F0143}';
        height: 20px;
        width: 20px;
      }

      .pic-containeHeaderRightLabel.mdi-chevron-down::before {
        font-family: 'Material Design Icons';
        content: '\u{F0140}';
        height: 20px;
        width: 20px;
      }

      .pic-containerheaderRightCol {
        display: flex;
        flex-direction: column;
      }

      .pic-containeHeaderRightCheckBox {
        position: absolute;
        opacity: 0;
        z-index: -1;
      }

      .pic-containerbody {
        background-color: white;
        display: flex;
        /* flex-flow: wrap; */
        flex-direction: column;
      }

      .pic-containerbodyhidden {
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transition: max-height 300ms ease, opacity 800ms ease;
      }

      .pic-containerbodyvisible {
        transition: max-height 300ms ease, opacity 800ms ease;
        opacity: 1;
        /* max-height: 100vh; */
        display: flex;
      }

      .pic-containerfooter {
        background-color: cyan;
      }

      .httpMethod {
        margin-top: 2px;
        width: 5rem;
        text-align: center;
        border-radius: 5px;
        color: white;
        text-transform: uppercase;
      }

      .httpMethod.post {
        background-color: var(--pic-statusInfoColor);
      }

      .httpMethod.put {
        background-color: var(--pic-statusWarningColor);
      }

      .httpMethod.get {
        background-color: var(--pic-statusOkColor);
      }

      .httpMethod.delete {
        background-color: var(--pic-statusErrorColor);
      }

      .endpointHdr {
        display: flex;
        text-transform: capitalize;
      }

      .endpointHdr > .pic-h4 {
        font-weight: bold;
      }

      .apiPath {
        text-transform: none;
        font-weight: bold;
      }

      .apiDesc {
        font-size: small;
      }

      .sectionOuterContainer {
        /* border: 1px solid black; */
        padding: 0rem 1rem;
      }

      .sectionContainerHdr {
        border-bottom: 1px solid black;
        padding: 0px 0rem 0rem 1rem;
        display: flex;
        justify-content: space-between;
      }
      
      .paramTable {
        width: 100%;
      }

      .paramTable td,
      .paramTable th {
        text-align: left;
        padding: 0px 10px;
      }
    `;
        return css `
      ${super.styles}
      ${defaultStyle}
    `;
    }
    constructor() {
        super();
        this.path = '';
        this.useEditor = false;
        this.responsesLimit = 1;
    }
    connectedCallback() {
        super.connectedCallback();
        this.getDataFromAPI();
    }
    /* MONACO editor stuff  */
    // private container: Ref<HTMLElement> = createRef();
    // private editor?: any;
    // private editorData_: string = "console.log('hello world');";
    // set editorData(iData: string) {
    //     this.editorData_ = iData;
    //     if (this.editor) this.editor.setValue(this.editorData_);
    //     this.requestUpdate();
    //   }
    // get editorData(): string {
    //     if (this.editor) return this.editor.getValue();
    //     else return this.editorData_;
    //  }
    // setEditor() {
    //     console.log('set editor calld');
    //     this.editor = window.monaco.editor.create(this.container.value!, {
    //       value: this.editorData,
    //       language: 'json',
    //     //   language: 'abl',
    //     //   theme: 'ablTheme',
    //       automaticLayout: true,
    //     });
    //   }
    // loadStyle() {
    //     let style = document.createElement('link');
    //     style.rel = 'stylesheet';
    //     style.href = 'https://udv.picit.dk/scripts/picit/monaco/editor.main.css';
    //     this.shadowRoot?.appendChild(style);
    //   }
    //   loadScript() {
    //     let script = document.createElement('script');
    //     // script.src = '../scripts/picit/monaco/main.bundle.js';
    //     script.src = 'https://udv.picit.dk/scripts/picit/monaco/main.bundle.js';
    //     script.onload = (() => {
    //         console.log('loaded script');
    //         // this.registerLanguage();
    //         // // this.registerLanguageConf();
    //         // this.registerTokens();
    //         // this.registerTheme();
    //         // // this.registerCompletionItemProvider();
    //         this.setEditor();
    //     }).bind(this)
    //     document.head.appendChild(script);
    //   }
    /* MONACO editor stuff  */
    getDataFromAPI() {
        let options = {
            // sessionId: PIC.sessionCode,
            systemId: PIC.systemId,
            postBody: { path: this.path },
        };
        fetchApiData('/test/apidocs', options)
            .then((data) => {
            this.apiData = data.endPoint;
            console.log('got api data', data, this.apiData);
            this.requestUpdate();
        })
            .catch((err) => console.log(err));
    }
    doURI(front, back) {
        let arr = location.hostname.split('.');
        arr[0] = front;
        return `${location.protocol}//${arr.join('.')}${back ? '/' + back : ''}`;
    }
    exportFetchCMD(options) {
        return `fetch("${this.doURI('rndapi', 'v1/cargonet/v1/booking')}", {
            "headers": {  },
            "referrer": "${this.doURI('rndweb')}",
            "referrerPolicy": "strict-origin-when-cross-origin",
            "body": "{}",
            "method": "POST",
            "mode": "cors",
            "credentials": "include"
          });`;
    }
    exportcURLCMD(iHM, options) {
        return `curl ${exportFetchHeaders().map(x => `-H '${x[0]}: ${x[1]}'`).join(' ')} -X ${iHM === null || iHM === void 0 ? void 0 : iHM.id.toUpperCase()} ${this.getURL(iHM, options)}`;
    }
    getOptions(postMethod, url, postBody) {
        let options;
        if (postMethod !== 'GET' && postBody) {
            options = {
                sessionId: PIC.sessionCode,
                systemId: PIC.systemId,
                method: postMethod,
                postBody: postBody,
                path: url,
                formatOutput: 'json',
                errorReturn: true,
            };
        }
        else {
            options = {
                sessionId: PIC.sessionCode,
                systemId: PIC.systemId,
                method: postMethod,
                path: url,
                formatOutput: 'json',
                errorReturn: true,
            };
        }
        return options;
    }
    getURL(iHM, options) {
        var _a;
        let firstPart = exportFetchURL(options);
        let secondPart = iHM ? (_a = iHM.queryParam) === null || _a === void 0 ? void 0 : _a.map(qp => qp.value ? `${qp.key}=${qp.value}&` : ``).join('') : undefined;
        return secondPart ? `${firstPart}?${secondPart.slice(0, -1)}` : firstPart;
    }
    updateRequestCMDs(iHM, contPath, iParam, fldId) {
        var _a;
        if (iParam && fldId) {
            let updater = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#' + fldId);
            if (updater)
                iParam.value = updater.submitValue;
        }
        iHM.request = { cURL: this.exportcURLCMD(iHM, { path: contPath }), fetch: this.exportFetchCMD({ path: contPath }) };
        this.requestUpdate();
    }
    onClickTryIt(postMethod, url, iHM) {
        var _a;
        let postBody = {};
        let curBodyTxtArea = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#txtBody_${url}_${iHM.id}`.replace(/\//g, '_'));
        if (curBodyTxtArea) {
            let textAreaData;
            if (this.useEditor)
                textAreaData = curBodyTxtArea.editorData;
            else
                textAreaData = curBodyTxtArea.submitValue;
            if (textAreaData) {
                try {
                    postBody = JSON.parse(textAreaData);
                }
                catch (_b) {
                    console.log('invalid JSON');
                }
            }
        }
        let URLwithParams = this.getURL(iHM, { path: url });
        URLwithParams = URLwithParams.slice(URLwithParams.indexOf(url));
        let options = this.getOptions(postMethod, URLwithParams, postBody);
        iHM.request = { cURL: this.exportcURLCMD(iHM, { path: url }), fetch: this.exportFetchCMD({ path: url }) };
        console.log('pre fetch', postBody, URLwithParams, options);
        fetchApiData(url, options)
            .then((data) => {
            if (!iHM.responses || iHM.responses.length + 1 > this.responsesLimit)
                iHM.responses = [];
            iHM.responses.push({
                code: '200',
                description: JSON.stringify(data, null, 2),
            });
            this.requestUpdate();
        })
            .catch((err) => {
            if (!iHM.responses)
                iHM.responses = [];
            iHM.responses.push({ code: '500', description: err });
            this.requestUpdate();
        });
    }
    onClickContainer(contId) {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#${contId} .pic-containerbody`)) === null || _b === void 0 ? void 0 : _b.classList.toggle('pic-containerbodyhidden');
        (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(`#${contId} .pic-containerbody`)) === null || _d === void 0 ? void 0 : _d.classList.toggle('pic-containerbodyvisible');
        let isVisible = (_e = this.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector(`#${contId} .pic-containerbody.pic-containerbodyvisible`);
        let curIcon = (_f = this.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelector(`#${contId} .pic-containeHeaderRightLabel`);
        curIcon === null || curIcon === void 0 ? void 0 : curIcon.classList.toggle('mdi-chevron-down');
        curIcon === null || curIcon === void 0 ? void 0 : curIcon.classList.toggle('mdi-chevron-up');
    }
    renderInputField(iId, iHM, contPath, iParam, iLbl) {
        var _a;
        let onChangeAction = new PICAction('internal', this.updateRequestCMDs.bind(this, iHM, contPath, iParam, iId));
        onChangeAction.trigger_ = 'change';
        return html `
      <pic-text
        .id_=${iId}
        .label=${iLbl !== null && iLbl !== void 0 ? iLbl : ''}
        .eType=${'default'}
        .density=${'inline'}
        .selfAction=${new PICAction('internal', this.onClickTryIt.bind(this, ((_a = iHM === null || iHM === void 0 ? void 0 : iHM.id) !== null && _a !== void 0 ? _a : iId).toUpperCase(), contPath, iHM))}
        .actionElements=${new Map().set('change', onChangeAction)}
      ></pic-text>
    `;
    }
    renderContainerParams(iHM, contPath) {
        var _a;
        if (iHM.queryParam)
            return html `
      <section>
        <div class="sectionOuterContainer">
          <div class="">${iHM.description}</div>
          <div class="sectionContainerHdr pic-h6">
            Query Parameters
            <pic-button
              .action=${new PICAction('internal', this.onClickTryIt.bind(this, iHM.id.toUpperCase(), contPath, iHM))}
              .width=${'10rem'}
              .eType=${'outlined'}
              .density=${'medium'}
              .label=${'Try it'}
            ></pic-button>
          </div>
          <table class="paramTable">
            <thead>
              <tr>
                <th>Id</th>
                <th>Key</th>
                <th>Value</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              ${(_a = iHM.queryParam) === null || _a === void 0 ? void 0 : _a.map((p) => html `<tr>
                  <td>${p.id}</td>
                  <td>${p.key}</td>
                  <td>
                    ${this.renderInputField(`fld_${contPath}_${iHM.id}_${p.key}`.replace(/\//g, '_'), iHM, contPath, p, '')}
                  </td>
                  <td>${p.description}</td>
                </tr> `)}
            </tbody>
          </table>
        </div>
      </section>
    `;
        else
            return html `
        <section>
            <div class="sectionOuterContainer">
                <div class="sectionContainerHdr">
                    <div class="">${iHM.description}</div>
                    <pic-button
                    .action=${new PICAction('internal', this.onClickTryIt.bind(this, iHM.id.toUpperCase(), contPath, iHM))}
                    .width=${'10rem'}
                    .eType=${'outlined'}
                    .density=${'medium'}
                    .label=${'Try it'}
                    ></pic-button>
                </div>
            </div>
        </section>
          `;
    }
    renderContainerBody(iHM, contPath) {
        var _a;
        let returnTemplate = html ``;
        if (iHM.body) {
            iHM.body = (_a = JSON.stringify(JSON.parse(iHM.body), null, 2)) !== null && _a !== void 0 ? _a : '';
            if (this.useEditor)
                returnTemplate = html `
        <section>
            <div class="sectionOuterContainer">
                <div class="sectionContainerHdr pic-h6">Body</div>
                <pic-editor 
                    .id=${`txtBody_${contPath}_${iHM.id}`.replace(/\//g, '_')}
                    .editorHeight=${`${this.getNumRowsTextArea(iHM.body) * 1.2}rem`}
                    .editorWidth=${'99%'}
                    .editorData=${iHM.body} 
                    .editorLanguage=${'json'}>
                </pic-editor>
            </div>
        </section>
        `;
            else
                returnTemplate = html `
        <section>
            <div class="sectionOuterContainer">
                <div class="sectionContainerHdr pic-h6">Body</div>
                <pic-textarea
                    .density=${'high'}
                    .id=${`txtBody_${contPath}_${iHM.id}`.replace(/\//g, '_')}
                    .label=${'Body'}
                    .value=${iHM.body}
                    .eType=${'default'}
                    .rows=${this.getNumRowsTextArea(iHM.body)}
                    .width=${this.getWidthTextArea(iHM.body)}
                ></pic-textarea>
            </div>
        </section>
        `;
        }
        return returnTemplate;
    }
    getNumRowsTextArea(iTxt) {
        let numRows = 1;
        if (iTxt) {
            try {
                numRows = iTxt.split(/\r\n|\r|\n/).length;
                numRows = numRows > 30 ? 30 : numRows;
            }
            catch (_a) {
                numRows = 1;
            }
        }
        return numRows;
    }
    getWidthTextArea(iTxt) {
        if (this.getNumRowsTextArea(iTxt) === 1) {
            if (iTxt.length) {
                // if (iTxt.length * 0.576 === NaN)
                //     return '15rem'
                // else 
                if (iTxt.length * 0.576 > 50)
                    return '50rem';
                else
                    return String(iTxt.length * 0.576) + 'rem';
            }
            else
                return '15rem';
        }
        else
            return '50rem';
    }
    renderContainerResponse(iHM) {
        let returnTemplate = html ``;
        if (iHM.responses) {
            if (this.useEditor)
                returnTemplate = html `
        <section>
          <div class="sectionOuterContainer">
            <div class="sectionContainerHdr pic-h6">Responses</div>
            <table class="paramTable">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                ${iHM.responses.map((r) => html `<tr>
                    <td>${r.code}</td>
                    <td>
                    <pic-editor 
                        .id=${'txtab'}
                        .editorHeight=${`${this.getNumRowsTextArea(r.description) * 1.2}rem`}
                        .editorWidth=${'99%'}
                        .editorData=${r.description} 
                        .editorLanguage=${'json'}>
                    </pic-editor>
                    </td>
                  </tr> `)}
              </tbody>
            </table>
          </div>
        </section>
      `;
            else
                returnTemplate = html `
      <section>
        <div class="sectionOuterContainer">
          <div class="sectionContainerHdr pic-h6">Responses</div>
          <table class="paramTable">
            <thead>
              <tr>
                <th>Code</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              ${iHM.responses.map((r) => html `<tr>
                  <td>${r.code}</td>
                  <td>
                    <pic-textarea
                      .density=${'high'}
                      .id=${'txtab'}
                      .label=${'Response'}
                      .value=${r.description}
                      .eType=${'default'}
                      .rows=${this.getNumRowsTextArea(r.description)}
                      .width=${this.getWidthTextArea(r.description)}
                    ></pic-textarea>
                  </td>
                </tr> `)}
            </tbody>
          </table>
        </div>
      </section>
    `;
        }
        return returnTemplate;
    }
    renderContainerExampels(iHM) {
        let returnTemplate = html ``;
        if (iHM.request) {
            if (this.useEditor)
                returnTemplate = html `
        <section>
          <div class="sectionOuterContainer">
            <div class="sectionContainerHdr pic-h6">Exampels</div>
                <pic-editor 
                    .id=${"editorExampels"}
                    .editorHeight=${`1.2rem`}
                    .editorWidth=${'99%'}
                    .editorData=${iHM.request.cURL} 
                    .editorLanguage=${'json'}
                    .enableMinimap=${false}
                    >
                </pic-editor>
          </div>
        </section>
      `;
            else
                returnTemplate = html `
      <section>
          <div class="sectionOuterContainer">
            <div class="sectionContainerHdr pic-h6">Exampels</div>
                <pic-textarea
                    .density=${'high'}
                    .id=${'txtab'}
                    .label=${'cURL'}
                    .value=${iHM.request.cURL}
                    .eType=${'default'}
                    .rows=${4}
                    .width=${this.getWidthTextArea(iHM.request.cURL)}
                ></pic-textarea>
                <!-- <pic-textarea
                    .density=${'high'}
                    .id=${'txtab'}
                    .label=${'fetch'}
                    .value=${iHM.request.fetch}
                    .eType=${'default'}
                    .rows=${this.getNumRowsTextArea(iHM.request.fetch)}
                    .width=${this.getWidthTextArea(iHM.request.fetch)}
                ></pic-textarea> -->
          </div>
        </section>
        `;
        }
        return returnTemplate;
    }
    renderContainerInnerHTML(iHM, contPath) {
        return html `
      ${this.renderContainerParams(iHM, contPath)}
      ${this.renderContainerBody(iHM, contPath)}
      ${this.renderContainerExampels(iHM)}
      ${this.renderContainerResponse(iHM)}
    `;
    }
    rendercontainer(contId, contMethod, contPath, contDesc, innerHTML) {
        return html `
      <div id=${contId} class="pic-container">
        <div
        class="pic-containerheadercollapsable"
        @click=${() => this.onClickContainer(contId)}
        >
          <div class="pointerContainer"></div>
          <div class="pic-containerheaderLeft">
            <div class="httpMethod ${contMethod} pic-h6">${contMethod}</div>
            <div class="apiPath pic-button">${contPath}</div>
            <div class="apiDesc pic-body1">${contDesc}</div>
          </div>
          <div class="pic-containerheaderRight">
            <input
              id="pic-containeHeaderRightCheckBox-${contId}"
              type="checkbox"
              @click=${() => this.onClickContainer(contId)}
              class="pic-containeHeaderRightCheckBox"
            /><label
              id="pic-containeHeaderRightLabel-${contId}"
              for="pic-containeHeaderRightCheckBox-${contId}"
              class="pic-containeHeaderRightLabel mdi-chevron-down"
            ></label>
          </div>
        </div>
        <div class="pic-containerbody pic-containerbodyhidden pic-body2">
          ${innerHTML}
        </div>
        <div class="pic-containerfooter"></div>
      </div>
    `;
    }
    renderHTTPMethod(endp, iHM) {
        this.updateRequestCMDs(iHM, endp.path);
        return html `
      ${this.rendercontainer(`${endp.id}_${iHM.id}`, iHM.id, endp.path, iHM.description, this.renderContainerInnerHTML(iHM, endp.path))}
    `;
    }
    render() {
        var _a;
        return html `
        ${this.renderCSS(true)}
      ${(_a = this.apiData) === null || _a === void 0 ? void 0 : _a.map((endp) => {
            var _a;
            return html `
          <div class="endpointHdr">
            <div class="pic-h4">${endp.id}</div>
            <div class="pic-h6">${endp.description}</div>
          </div>
          ${(_a = endp.httpMethod) === null || _a === void 0 ? void 0 : _a.map((httpm) => this.renderHTTPMethod(endp, httpm))}
        `;
        })}
    `;
    }
};
__decorate([
    property({ converter: stringDecoder })
], PICAPIDocs.prototype, "path", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'useeditor' })
], PICAPIDocs.prototype, "useEditor", void 0);
__decorate([
    property({ converter: numberDecoder, attribute: 'responseslimit' })
], PICAPIDocs.prototype, "responsesLimit", void 0);
PICAPIDocs = __decorate([
    customElement('pic-apidocs')
], PICAPIDocs);
export { PICAPIDocs };
//# sourceMappingURL=PICAPIDocs.js.map